import React from 'react';
import { useSelector } from 'react-redux';
import { Map } from 'immutable';

import { CoreLink } from '@uncinc/react-drupal-core';
import { MagicLine } from '@uncinc/uncinc-react-kitchen-sink';

import { LANGUAGE_DUTCH, LANGUAGE_ENGLISH } from '../../config/constants';

import './style.scss';

const LanguageSwitcher = ({ setActiveOverlayMenu = null }) => {
  const entityType = useSelector((state) => state.getIn(['entity', 'entityType'], null));
  const entityId = useSelector((state) => state.getIn(['entity', 'entityId'], null));
  const entity = useSelector((state) => state.getIn([entityType, entityId], Map()));
  const currentLanguage = useSelector((state) => state.getIn(['ui', 'language']));

  const isFront = entity.getIn(['is_front']);

  const rootPathNL = `/${LANGUAGE_DUTCH}`;
  const rootPathEN = `/${LANGUAGE_ENGLISH}`;
  const pathNL = isFront ? rootPathNL : entity.getIn(['paths', LANGUAGE_DUTCH], rootPathNL);
  const pathEN = isFront ? rootPathEN : entity.getIn(['paths', LANGUAGE_ENGLISH], rootPathEN);

  const otherLangcode = (currentLanguage === LANGUAGE_ENGLISH ? LANGUAGE_DUTCH : LANGUAGE_ENGLISH);

  if (entity.getIn(['paths', otherLangcode])) {
    return (
      <div className="LanguageSwitcher">
        <MagicLine activeClassName="selected">
          {(setInitialMagicLine, hoverMagicLine) => (
            <div className="LanguageSwitcher__wrapper"
              onClick={() => {
                if (setActiveOverlayMenu) {
                  setActiveOverlayMenu(null);
                }
              }}
            >
              <div
                className={`LanguageSwitcher__item ${currentLanguage === LANGUAGE_DUTCH && 'selected'}`}
                onMouseEnter={(e) => hoverMagicLine(e)}
                onMouseLeave={() => setInitialMagicLine()}
              >
                <CoreLink href={pathNL}>NL</CoreLink>
              </div>
              <div
                className={`LanguageSwitcher__item ${currentLanguage === LANGUAGE_ENGLISH && 'selected'}`}
                onMouseEnter={(e) => hoverMagicLine(e)}
                onMouseLeave={() => setInitialMagicLine()}
              >
                <CoreLink href={pathEN}>EN</CoreLink>
              </div>
            </div>
          )}
        </MagicLine>
      </div>
    );
  } else {
    return null;
  }
};

export default LanguageSwitcher;
